module.exports = __webpack_public_path__ + "static/fonts/iconosVidaSoftware.5a93372.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.eot
// module id = 6/lO
// module chunks = 3